<template>
    <div class="qa_item">
        <div class="qa_item__q" @click="toggle">
            <span>Q</span>
            <p class="mb-0 ms-2">
                <slot name="question"></slot>
            </p>
            <i class="bi bi-dash-lg" v-if="isOpen"></i>
            <i class="bi bi-plus-lg" v-else></i>
        </div>
        <transition name="fade">
            <div class="qa_item__a" v-show="isOpen">
                <span>A</span>
                <p class="mb-0 ms-2">
                    <slot name="answer"></slot>
                </p>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isOpen: false,
        };
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
        },
    },
};
</script>
